module.exports = __webpack_public_path__ + "ce14a6f1c97c5d49267b7b05239c60ce.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/texas-camp-newsletter.png
// module id = 984
// module chunks = 2